import { RouteObject } from 'react-router'
import { Overview } from './overview'
import { Root } from './root'

export const HOME_ROUTES: RouteObject = {
	path: '',
	element: <Root />,
	children: [
		{
			path: '',
			element: <Overview />,
		},
	],
}
